import { render, staticRenderFns } from "./CustomerFilter.vue?vue&type=template&id=64386f76"
import script from "./CustomerFilter.vue?vue&type=script&lang=ts"
export * from "./CustomerFilter.vue?vue&type=script&lang=ts"
import style0 from "./CustomerFilter.vue?vue&type=style&index=0&id=64386f76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports